import { Product } from '~/modules/catalog/product/types'

export const LAST_VIEWED_PRODUCTS_KEY = 'lastViewedProductSkus'
export const LAST_VIEWED_MAX_NUMBER = 10

export interface LastViewedProductsStateInterface {
  products: Product[]
}
